import { InfoCircle } from "react-bootstrap-icons";
import { useAppDispatch, useAppSelector } from "state/hooks.ts";
import { 
  getPaynoteFundingSourcesState
} from "state/slices/paynote-funding-sources-slice.ts";
import { 
  getDepositFundsModalState, 
  setSelectedPaymentMethod,
  hideDepositModalV2
} from "state/slices/deposit-funds-modal-v2-slice.ts";
import { PaynoteFundingSource } from "interfaces/commerce/paynote/paynote-funding-source.ts";
import BlockyLightText from "components/custom-texts/blocky-light-text.tsx";
import PaynoteFundingSourceSelector from "./paynote-funding-source-selector.tsx";
import { sparketLightGray, ACH_MINIMUM_DEPOSIT } from "utils/constants.ts";

const DepositFundsModalAchPaymentBlock = () => {
  const dispatch = useAppDispatch();
  const fundingSourcesState = useAppSelector(getPaynoteFundingSourcesState);
  const modalState = useAppSelector(getDepositFundsModalState);

  // Get the selected ACH account ID from the modal state
  const selectedAccountId = modalState.selectedPaymentMethod?.type === 'ACH' 
    ? modalState.selectedPaymentMethod.paynoteFundingSourceId 
    : undefined;

  // Find the selected funding source object
  const selectedMethod = selectedAccountId 
    ? fundingSourcesState.fundingSources.find(source => source.id === selectedAccountId)
    : undefined;

  const handleMethodSelect = (method: PaynoteFundingSource) => {
    dispatch(setSelectedPaymentMethod({ 
      type: 'ACH', 
      paynoteFundingSourceId: method.id 
    }));
  };

  const handleClose = () => {
    dispatch(hideDepositModalV2());
  };

  return (
    <div>
      {/* Red warning message about ACH settling speed */}
      <div className="mb-3 text-center">
        <BlockyLightText style={{ 
          color: "#ff4444", 
          fontSize: "13px",
          position: "relative",
          padding: "12px 16px",
          backgroundColor: "rgba(255, 68, 68, 0.1)",
          borderRadius: "6px",
          border: "1px solid rgba(255, 68, 68, 0.3)",
          lineHeight: "1.4"
        }}>
          <InfoCircle size={16} style={{ 
            position: "absolute",
            top: "8px",
            right: "8px",
            opacity: 0.7
          }} />
          <div>
            <div style={{ fontWeight: 600, marginBottom: "8px" }}>
              Bank transfers take 24+ hours to settle
            </div>
            <div style={{ fontSize: "12px", opacity: 0.9, marginBottom: "8px" }}>
            If you want to play right away, choose card payment
            </div>
            <div style={{ fontSize: "13px", opacity: 1, borderTop: "1px solid rgba(255, 68, 68, 0.2)", paddingTop: "6px" }}>
              Minimum: ${ACH_MINIMUM_DEPOSIT}
            </div>
          </div>
        </BlockyLightText>
      </div>
      
      <PaynoteFundingSourceSelector
        selectedMethod={selectedMethod}
        onMethodSelect={handleMethodSelect}
        onClose={handleClose}
        returnUrl="/profile?openDepositModal=true"
      />
    </div>
  );
};

export default DepositFundsModalAchPaymentBlock; 